import { render, staticRenderFns } from "./MSOCouponEditor.vue?vue&type=template&id=4812f0d5&scoped=true&"
import script from "./MSOCouponEditor.vue?vue&type=script&lang=js&"
export * from "./MSOCouponEditor.vue?vue&type=script&lang=js&"
import style0 from "./MSOCouponEditor.vue?vue&type=style&index=0&id=4812f0d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4812f0d5",
  null
  
)

export default component.exports